import { IconHelp, IconPersonAssist } from '@veneer/core';
import React from 'react';
import { URLS } from 'src/utils/urls';
import {
  ProLiveSupportButtonClicked,
  GetInstantInkSupportButtonClicked
} from '../analytics';
import {
  ROW_TYPE,
  SubscriptionType,
  Loading,
  CardRowProps
} from '@uma/react-commons/dist/index';
import { SubscriptionsProps } from '../../SubscriptionsCard/types';

export function getHaveQuestionsRows({
  subscription,
  translate
}: {
  subscription: SubscriptionsProps;
  translate: (
    key: string,
    defaultValue?:
      | string
      | { defaultValue: string; replace?: Record<string, string> }
  ) => string;
}): CardRowProps[] {
  if (
    subscription?.type !== SubscriptionType.HP_ALL_IN &&
    subscription?.type !== SubscriptionType.INSTANT_INK
  ) {
    return [];
  }

  if (subscription?.type == SubscriptionType.HP_ALL_IN) {
    return [
      {
        index: 0,
        icon: <IconPersonAssist size={24} />,
        type: ROW_TYPE.EXTERNAL,
        content: translate(
          'subscriptions.proLiveSupport',
          '24/7 Pro live support'
        ) as string,
        link: {
          url: URLS.ProLiveSupport,
          dataTestId: 'ProLiveSupport'
        },
        analyticsEvent: ProLiveSupportButtonClicked
      }
    ];
  }

  return [
    {
      index: 0,
      content: <Loading />,
      type: ROW_TYPE.NONE
    },
    {
      index: 2,
      icon: <IconHelp />,
      type: ROW_TYPE.EXTERNAL,
      content: translate(
        'subscriptions.getInstantInkSupport',
        'Get Instant Ink support'
      ) as string,
      link: {
        url: URLS.GetInstantInkSupport,
        dataTestId: 'GetInstantInkSupportLink'
      },
      analyticsEvent: GetInstantInkSupportButtonClicked(
        subscription.resourceId,
        subscription.startDate
      ),
      internalKey: 'card-row-2'
    }
  ];
}
